import { useEffect, useRef } from 'react';
import { useAdminStore } from '@/stores/adminStore';
import { fetchAdminDashboard } from '@/api/admin';

const POLL_INTERVAL = 12_000; // 12 seconds

export function useAdminPanel() {
  const isOpen = useAdminStore((s) => s.isOpen);
  const updateDashboard = useAdminStore((s) => s.updateDashboard);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (!isOpen) return;

    let mounted = true;

    const poll = async () => {
      try {
        const data = await fetchAdminDashboard();
        if (!mounted) return;
        updateDashboard(data);
      } catch {
        // ignore — panel shows stale data
      }
      if (mounted) {
        timerRef.current = setTimeout(poll, POLL_INTERVAL);
      }
    };

    poll();

    return () => {
      mounted = false;
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [isOpen, updateDashboard]);
}
